import React from 'react'
import { makeStyles, Typography, Box } from '@material-ui/core'
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(theme => ({
  footer: {
    padding: theme.spacing(2, 3),
    marginTop: 'auto',
    backgroundColor: theme.palette.type === 'dark' ? theme.palette.grey[800] : theme.palette.grey[100],
    borderTop: `1px solid ${theme.palette.divider}`,
  },
  footerContent: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
}));

const Footer = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <footer className={classes.footer}>
      <Box className={classes.footerContent}>
        <Typography align="center" color="textSecondary" variant="body2">
          {'Copyright © '}
          {t('company_name')}
          {' '}
          {new Date().getFullYear()}
          {'.'}
        </Typography>
      </Box>
    </footer>
  )
};

export default Footer;
